import urljoin from 'url-join'

export function urlJoin(baseUrl?: string, path?: string): string {
  if (baseUrl && path) {
    return urljoin(baseUrl, path)
  }
  
  return ''
}